import { jsx as _jsx } from "react/jsx-runtime";
import InputAdornment from '@mui/material/InputAdornment';
import { Icon } from '@famly/mf_data-display_icon';
export const IconAdornment = ({ position, icon, size, color, filled }) => {
    return (_jsx(InputAdornment, { position: position, children: _jsx(Icon, { size: size === 'regular' ? 24 : 20, name: icon, color: color, filled: filled }) }));
};
